export default {
  SET_COLOR_MODE: 'colorMode/SET_COLOR_MODE',
};
